import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";

const DonationChart = ({ pastWeekDonations }) => {
  const lineRef = useRef(null);
  useEffect(() => {
    if (pastWeekDonations?.length > 0) {
      window.Apex = {
        chart: { foreColor: "#ccc", toolbar: { show: false } },
        stroke: { width: 3 },
        dataLabels: { enabled: false },
        tooltip: { theme: "dark" },
        grid: { borderColor: "#535A6C", xaxis: { lines: { show: true } } },
      };

      const mountChart = (ref, options) => {
        const el = ref.current;
        if (el) {
          const chart = new ApexCharts(el, options);
          chart.render();
        }
      };
      const dates = pastWeekDonations?.map((m) => m.date);
      const donationsData = [
        {
          name: "countries",
          data: pastWeekDonations?.map((item) => item?.countries),
        },
        {
          name: "Provinces",
          data: pastWeekDonations?.map((item) => item?.provinces),
        },
        {
          name: "Cities",
          data: pastWeekDonations?.map((item) => item?.cities),
        },
      ];
      const optionsLine = {
        chart: {
          height: 328,
          type: "line",
          zoom: { enabled: false },
          dropShadow: { enabled: true, top: 3, left: 2, blur: 4, opacity: 1 },
        },
        stroke: { curve: "smooth", width: 2 },
        series: donationsData,
        title: { text: "Donation", align: "left", offsetY: 25, offsetX: 20 },
        markers: { size: 6, strokeWidth: 0, hover: { size: 9 } },
        grid: { show: true, padding: { bottom: 0 } },
        labels: dates,
        xaxis: { tooltip: { enabled: false } },
        legend: { position: "top", horizontalAlign: "right", offsetY: -20 },
      };

      mountChart(lineRef, optionsLine);
    }
  }, [pastWeekDonations]);
  return (
    <div className="col-md-12">
      <div className="box shadow mt-4 p-4 rounded cardBox text-ligth">
        <h5 className="text-center fw-bold mb-3">Total Donation</h5>
        <div id="line-adwords" ref={lineRef} />
      </div>
    </div>
  );
};

export default DonationChart;
